import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/core/react/router';

import { useSapToDm } from './hooks/useSapToDm';

export function SapToDm(): React.JSX.Element {
	const {
		data: { displayName, id, formattedLocation, showNeighborhoodCheck },
		actions: { trackSapClick },
	} = useSapToDm();

	return (
		<div className="space-y-6 rounded-xl bg-gradient-background-dark-3 p-4 text-left text-typography-inverse-strong md:p-10">
			<Text as="h2" variant="heading">
				<Translate value="corgi.decision_maker_profile.sap_to_dm.heading" replacements={{ displayName }} />
			</Text>
			<Text as="p" variant="body">
				{showNeighborhoodCheck && (
					<>
						<Translate
							value="corgi.decision_maker_profile.sap_to_dm.description.neighborhood_check"
							replacements={{ location: formattedLocation }}
						/>{' '}
					</>
				)}
				<Translate value="corgi.decision_maker_profile.sap_to_dm.description.cta" replacements={{ displayName }} />
			</Text>
			<div className="flex justify-center md:justify-start">
				<Button
					to={`/start-a-petition?source_location=dm_profile_page&decision_maker_id=${id}`}
					as={Link}
					variant="primary"
					className="whitespace-normal md:w-fit"
					data-qa="dm-sap-cta-button"
					onClick={trackSapClick}
				>
					<Translate value="corgi.decision_maker_profile.sap_to_dm.button" replacements={{ displayName }} />
				</Button>
			</div>
		</div>
	);
}
